





















import {Component, Prop, Vue, Mixins, Watch} from "vue-property-decorator";
import DatePick from 'vue-date-pick/src/vueDatePick.vue';
import CalendarSvg from '../../../../../../assets/svg/calendar.svg';
import {getVueDatePickLocale} from "@common/vueDatePick";
import DatePickerInput from '@share/common/form/form-controls/date/date-picker/DatePickerInput.vue';
import { validationMixin } from "vuelidate";
import { isDateTime } from "@common/validation/date";

const getValidationObject = (externalValidations: { [key: string]: any }) => {
    const validations: { [key: string]: any } = {
        start: {
            isDateTime
        },
        end: {
            isDateTime
        }
    };

    Object.keys(externalValidations).forEach((key: string) => {
        if (validations[key]) {
            validations[key] = {
                ...validations[key],
                ...externalValidations[key]
            }
        } else {
            validations[key] = externalValidations[key];
        }
    })

    return validations;
}

@Component({
    components: {CalendarSvg, DatePick, DatePickerInput},
    validations() {
        return getValidationObject((this as DatePickerRange).validations)
    }
})
export default class DatePickerRange extends Mixins(validationMixin) {
    @Prop({default: { 'start': '', 'end': '' }}) declare value: { [key: string]: any };
    @Prop({default: 'en'}) lang: string;
    @Prop({ default: "" }) placeholderStart: string | undefined;
    @Prop({ default: "" }) placeholderEnd: string | undefined;
    @Prop({ default: "" }) filterName: string | undefined;
    @Prop({ default: () => { return {} } }) validations: { [key: string]: any };

    datePickLocale: any = {};

    validate() {
        this.$v.$touch();
    }

    @Watch('$v', {deep: true})
    checkValidate(validation: any) {
        this.$emit("setErrorsValidation", (validation.start.$error || validation.end.$error) ? false : true);
    }

    mounted() {
        this.datePickLocale = getVueDatePickLocale(this.lang);
    }

    get start() {
        return this.value.start ?? '';
    }

    set start(value) {
        if (value && this.end) {
            let end: Date = new Date(this.end);
            let start: Date = new Date(value);
            if (start > end) {
                value = '';
            }
        }

        Vue.set(this.value, 'start', value);
        this.$emit("changed", this.value, this.filterName);
    }

    get end() {
        return this.value.end ?? '';
    }

    set end(value) {
        if (value && this.start) {
            let end: Date = new Date(value);
            let start: Date = new Date(this.start);
            if (start > end) {
                value = '';
            }
        }

        Vue.set(this.value, 'end', value);
        this.$emit("changed", this.value, this.filterName);
    }
}

